import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../lib/business";

export default function Header() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-border"
    >
      <div className="container-x flex items-center justify-between h-24 sm:h-28">
        <Link to="/" className="flex items-center group" data-testid="header-logo-link" aria-label="Abid Home Solutions home">
          <img
            src={BUSINESS.logo}
            alt="Abid Home Solutions LLC"
            className="h-16 sm:h-20 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "text-primary bg-secondary" : "text-muted-foreground hover:text-primary hover:bg-secondary"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-now-btn"
            className="btn-ghost-dark text-sm px-3 py-2"
          >
            <Phone size={16} /> Call or Text: {BUSINESS.phone}
          </a>
          <Link
            to="/contact"
            data-testid="header-request-estimate-btn"
            className="btn-gold text-sm px-3 py-2"
          >
            Request Free Estimate
          </Link>
        </div>

        <button
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-lg border border-border"
          onClick={() => setOpen(true)}
        >
          <Menu size={20} />
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-[60] bg-primary text-white lg:hidden" data-testid="mobile-menu">
          <div className="container-x flex items-center justify-between h-20">
            <img src={BUSINESS.logo} alt="Abid Home Solutions LLC" className="h-12 w-auto object-contain bg-white rounded-lg p-1" />
            <button
              aria-label="Close menu"
              data-testid="mobile-menu-close"
              className="h-10 w-10 inline-flex items-center justify-center rounded-lg border border-white/20"
              onClick={() => setOpen(false)}
            >
              <X size={20} />
            </button>
          </div>
          <nav className="container-x flex flex-col gap-1 mt-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-2xl font-semibold py-3 border-b border-white/10 ${
                    isActive ? "text-accent" : "text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="mt-6 flex flex-col gap-3">
              <a href={BUSINESS.phoneHref} className="btn-gold" data-testid="mobile-call-now-btn">
                <Phone size={18} /> Call or Text {BUSINESS.phone}
              </a>
              <Link to="/contact" onClick={() => setOpen(false)} className="btn-outline-light" data-testid="mobile-request-estimate-btn">
                Request Free Estimate
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
